import request from './adminRequest'

const permissionApi = {
  createPermission (data) {
    return request.post('/permissions', data)
  },
  updatePermissionSortNum (id, data) {
    return request.put('/permissions/' + id, data)
  },
  deletePermission (id) {
    return request.delete('/permissions/' + id)
  },
  listPermissions (id) {
    return request.get('/permissions/businesses/' + id)
  },
  listAllPermissions (params) {
    return request.get('/permissions', { params: params })
  },
  listPermissionGroupByBusiness () {
    return request.get('/permissions/groupByBusiness')
  },
}

export default permissionApi
